import React, { useEffect, useState } from "react";
import {
  f7,
  Page,
  Link,
  Navbar,
  NavTitle,
  NavRight,
  Button,
  Badge,
  Toolbar,
  Tabs,
  Tab,
  Block,
  BlockTitle,
  Popup,
  Card,
  CardHeader,
  CardContent,
  CardFooter,
  List,
  ListItem,
  ListItemCell,
  ListInput,
  Icon,
  Range,
  Row,
  Col,
  Input,
  AccordionItem,
  AccordionToggle,
  AccordionContent,
} from "framework7-react";
import DeliveryPriceState from "./deliveryPriceState";

function DeliveryPriceCountry({
  country,
  states,
  editDeliveryPrice,
  deleteDeliveryPrice,
}) {
  const [stateSearch, setStateSearch] = useState("");
  const randomID = Math.floor(Math.random() * 100000);
  return (
    <Card style={{ width: "100%", margin: "10pt auto" }} >
      <AccordionItem
        onAccordionOpened={(_) => {
          document.getElementById(`${randomID}`).style.transform =
            "rotate(180deg)";
        }}
        onAccordionClosed={(_) => {
          document.getElementById(`${randomID}`).style.transform =
            "rotate(0deg)";
        }}
      >
        <AccordionToggle>
          <CardHeader className="no-border">
            <span>{country}</span>
            <span>
              <Button
                outline
                iconF7="arrowtriangle_down_fill"
                id={`${randomID}`}
              ></Button>
            </span>
          </CardHeader>
        </AccordionToggle>
        <AccordionContent>
          <CardContent className="bg-color-white no-padding">
            <Card className=" m-0">
              <CardHeader className="p-16 justify-start items-center">
                <Icon f7="search" style={{ width: 18, height: 18 }} />
                <Input
                  type="text"
                  placeholder="Search for state..."
                  className="px-8 flex-grow"
                  value={stateSearch}
                  onChange={(e) => setStateSearch(e.target.value)}
                />
              </CardHeader>
              <CardContent className="p-8 bg-color-gray-100">
                {Object.keys(states).length &&
                  Object.keys(states)
                    .filter((state) =>
                      state.toLowerCase().includes(stateSearch.toLowerCase())
                    )
                    .sort()
                    .map((state) => (
                      <DeliveryPriceState
                        key={state}
                        country={country}
                        state={state}
                        cities={states[state]}
                        editDeliveryPrice={editDeliveryPrice}
                        deleteDeliveryPrice={deleteDeliveryPrice}
                      />
                    ))}
              </CardContent>
            </Card>
          </CardContent>
        </AccordionContent>
      </AccordionItem>
    </Card>
  );
}

export default DeliveryPriceCountry;
